import React from 'react';
import { FlexBox, ResponsiveImage, Spinner, Typography, tokensRaw, useScreenClass } from '@vp/swan';
import styled from 'styled-components';
import { PreviewModal, PreviewModalVariant } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import { Image } from './StartingProjectDisplay';

export interface StartingProjectImagesProps {
    images: Image[] | undefined;
}

const StyledResponsiveImage = styled(ResponsiveImage)`
    object-fit: cover;
    cursor: zoom-in;
    width: 100%;
`;

export default function StartingProjectImages({ images }: StartingProjectImagesProps) {
    const [isOpen, setIsOpen] = React.useState(false);
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const screenClass = useScreenClass();

    if (!images) {
        return <Spinner accessibleText={__('Loading…')} />;
    }

    return (
        <>
            <PreviewModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                previewFiles={images}
                variant={PreviewModalVariant.WORK_ENTITY}
            />
            {images.map((image, i) => (
                <FlexBox
                    style={{
                        height: '80px',
                        width: '80px',
                        borderRadius: tokensRaw.SwanSemBorderRadiusStandard,
                    }}
                    flexDirection={'column'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    py={'4'}
                    px={'1'}
                    mr="5"
                    {...(screenClass === 'xs' ? { mt: 4 } : {})}
                    backgroundColor="standard"
                >
                    <StyledResponsiveImage
                        src={image.url}
                        alt={image.title}
                        pt={4}
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            setCurrentSlide(i);
                            setIsOpen(!isOpen);
                        }}
                    />
                    <Typography fontSize="xsmall" textAlign="center">
                        {image.title}
                    </Typography>
                </FlexBox>
            ))}
        </>
    );
}
